import {Injectable} from '@angular/core';
import {ToolsService} from '../../../services/tools.service';
import {EnumsService} from '../../../services/enums.service';
import {UrlValidatorService} from '../../../services/url-validator.service';
import {ActivatedRouteSnapshot, Params} from '@angular/router';
import {UrlTermsSymbolsEnum} from '../../../enums/SeoEnums';
import {RoutesEnums, RoutesQueryParamsEnum} from '../../../enums/RoutesEnums';
import {AllowedParamGroup} from '../../../types/AllowedParamGroup';
import {UrlBuilderService} from '../../../services/url-builder.service';

@Injectable()
export class GuideUrlResolverService {
  public tagName: string;

  constructor(
    private tools: ToolsService,
    private enumsService: EnumsService,
    private urlValidator: UrlValidatorService,
    private urlBuilder: UrlBuilderService,
  ) {}

  public resetState(): void {
    this.tagName = null;
  }

  public cleanUpUrl(snapshot: ActivatedRouteSnapshot): boolean {
    const allowedQueryParams: string[] = [
      UrlTermsSymbolsEnum.PAGE,
      RoutesQueryParamsEnum.GOOGLE_AD_PREVIEW,
      RoutesQueryParamsEnum.GOOGLE_AD_PREVIEW_IU,
      RoutesQueryParamsEnum.GOOGLE_AD_PREVIEW_GDFP,
      RoutesQueryParamsEnum.GOOGLE_AD_PREVIEW_LINEID,
      RoutesQueryParamsEnum.GOOGLE_AD_PREVIEW_CREATIVEID,
      RoutesQueryParamsEnum.GCLID,
      RoutesQueryParamsEnum.UTM_CAMPAIGN,
      RoutesQueryParamsEnum.UTM_SOURCE,
      RoutesQueryParamsEnum.UTM_MEDIUM,
      RoutesQueryParamsEnum.UTM_SIZE,
      RoutesQueryParamsEnum.UTM_TERM,
      RoutesQueryParamsEnum.UTM_CONTENT,
      RoutesQueryParamsEnum.FBCLID,
      RoutesQueryParamsEnum.FBQBTID,
    ];

    const allowedParamsGroups: AllowedParamGroup[] = [];
    allowedParamsGroups.push({
      params: [
        {
          type: 'string',
          value: RoutesEnums.TAG,
        },
        {
          type: 'string',
          value: null,
        },
      ],
    });

    allowedParamsGroups.push({
      params: [
        {
          type: 'string',
          value: null,
        },
      ],
    });

    const routingBase: string[] = this.urlBuilder.CreateGuideRouterLink();
    return this.urlValidator.cleanUpUrlAndRedirect(snapshot, routingBase, allowedParamsGroups, allowedQueryParams);
  }

  public processRouteQueryParams(params: Params): void {}

  public processRouteParams(params: Params): void {
    if (!this.tools.isNil(params.tag)) {
      this.tagName = params.tag;
    }
  }
}
